import type { MovementRegistryCategory, MovementRegistryEntry } from "@lemonadetraining/contracts";

export interface FilterOptions {
  query: string;
  category: MovementRegistryCategory | "all";
}

export function filterMovements(
  movements: ReadonlyArray<MovementRegistryEntry>,
  { query, category }: FilterOptions
): MovementRegistryEntry[] {
  const q = query.trim().toLowerCase();
  return movements.filter((m) => {
    if (category !== "all" && m.category !== category) return false;
    if (!q) return true;
    if (m.nameNormalized.includes(q)) return true;
    return m.tags.some((t) => t.toLowerCase().includes(q));
  });
}
